<isophi-info-popup
  *transloco="let t"
  [title]="t('demo/title')"
  [continueLabel]="t('demo/popup/continue')"
  [dontShowAgain]="dontShowAgain"
  (dontShowAgainChange)="onDontShowAgainChange($event)"
  (closed)="close()"
>
  <img src="../../../../../assets/img/demo-popup.jpeg" alt="" />
  <div class="text-wrapper">
    <div [innerHTML]="t('demo/popup/text1')"></div>
    <div [innerHTML]="t('demo/popup/text2')"></div>
    <div [innerHTML]="t('demo/popup/text3')"></div>
    <div [innerHTML]="t('demo/popup/text4')"></div>
    <div [innerHTML]="t('shared/popup/contact')"></div>
  </div>
</isophi-info-popup>
